document.addEventListener("DOMContentLoaded", function () {
      const faqWrappers = document.querySelectorAll('.faq__content');
      let mainEntity = [];

      faqWrappers.forEach(wrapper => {
        const items = wrapper.querySelectorAll('details');

        items.forEach(item => {
          const questionEl = item.querySelector('summary');
          const answerEl = item.querySelector('.accordion__content .prose');

          if (questionEl && answerEl) {
            const questionText = questionEl.innerText.trim();
            const answerHTML = answerEl.innerHTML.trim();

            if (questionText && answerHTML) {
              mainEntity.push({
                "@type": "Question",
                "name": questionText,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": answerHTML
                }
              });
            }
          }
        });
      });

      // Prevent duplicate schema
      if (mainEntity.length && !document.querySelector('#faq-schema')) {
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "faq-schema";

        script.innerHTML = JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": mainEntity
        });

        document.head.appendChild(script);
      }
    });